import React, {useEffect, useRef, useState} from "react";
import {AddMenuStyles} from "components/atoms/MenuManagement/MenuManagement.styles";
import {useForm} from "components/molecules/Form";
import Field from "components/molecules/Field";
import Form from "components/molecules/Form/Form";
import Button from "components/molecules/Button";
import {IoMdArrowDropdown} from "react-icons/io";
import {MdDelete} from "react-icons/md";
import menuStoreService from "services/menu-storeService";
import {useSelector} from "react-redux";
import Toast from "components/molecules/Toast";
import SubChoiceModal from "./SubChoiceModal";
import ModalContainer from "components/molecules/ModalContainer";
import { useAuthContext } from "Context/authContext";

const ChoiceModal = ({
    editChoice,
    onClose,
    setGroupChoices,
    groupData,
    index,
    groupChoices,
    onSuccess,
    choiceGroupData,
}) => {
    const [form] = useForm();
    const [loading, setLoading] = useState(false);
    const dropdownOptions = ["Available", "Unavailable"];
    const [openDropdownIndex, setOpenDropdownIndex] = useState(null);

    // Each choice now supports subChoices array
    const [formState, setFormState] = useState([
        {choiceName: "", price: "", calories: "", availability: "Available", subChoices: []},
    ]);

    const defaultStore = useSelector(state => state.business.defaultStore);
    const id = useSelector(state => state.business?.businessId);
    const {user} = useAuthContext();
    const businessId = id || user?.businessId;
    
console.log(businessId, 'businessId');
console.log(defaultStore, 'defaultStore');
    const isStandaloneChoiceGroup = !setGroupChoices && onSuccess;
    const dataToUse = isStandaloneChoiceGroup ? choiceGroupData : groupData;

    useEffect(() => {
        // inner async so we can await
        const prepareData = async () => {
            try {
                if (!editChoice || !dataToUse) return;

                // If dataToUse already has choices array, use it directly.
                // Otherwise fetch full details from backend by id.
                let fullGroup = dataToUse;
                if (!dataToUse.choices || dataToUse.choices.length === 0) {
                    // dataToUse might be a summary item from the list. Try to fetch full details.
                    if (dataToUse._id) {
                        const resp = await menuStoreService.getChoiceGroupById(dataToUse._id);
                        if (resp && resp.data) {
                            fullGroup = resp.data;
                        } else {
                            // fallback to using summary (avoid crash)
                            fullGroup = dataToUse;
                        }
                    }
                }

                const choiceDetails = fullGroup.choiceDetails || fullGroup.choices || [];

                const updatedState = choiceDetails.map(item => ({
                    choiceName: item.choiceName || "",
                    price: item.price ?? "",
                    calories: item.calories ?? "",
                    availability: item.availability || "Available",
                    // preserve existing nested subChoices if present
                    subChoices: item.subChoices || item.sub_choices || [],
                }));

                setFormState(
                    updatedState.length
                        ? updatedState
                        : [{choiceName: "", price: "", calories: "", availability: "Available", subChoices: []}]
                );

                form.setFieldsValue({
                    groupName: fullGroup.groupName,
                    minChoice: fullGroup.minChoice,
                    maxChoice: fullGroup.maxChoice,
                    isRequired: fullGroup.isRequired ? "true" : "false",
                });

                const fieldValues = choiceDetails
                    .map((item, ind) => ({
                        [`choiceName${ind}`]: item.choiceName || "",
                        [`price${ind}`]: item.price || "",
                        [`calories${ind}`]: item.calories || "",
                    }))
                    .reduce((acc, curr) => ({...acc, ...curr}), {});

                form.setFieldsValue(fieldValues);
            } catch (err) {
                // non-fatal: keep UI present but log error
                console.error("Failed to load full choice group details:", err);
            }
        };

        prepareData();
        // keep same deps as before
    }, [editChoice, groupData, choiceGroupData, form, isStandaloneChoiceGroup]);

    const addFeilds = () => {
        const newFormState = [
            ...formState,
            {choiceName: "", price: "", calories: "", availability: "Available", subChoices: []},
        ];
        
        // Re-sync all form field values including minChoice/maxChoice to prevent validation errors
        const currentValues = form.getFieldsValue();
        setTimeout(() => {
            form.setFieldsValue({
                groupName: currentValues.groupName,
                minChoice: currentValues.minChoice,
                maxChoice: currentValues.maxChoice,
                isRequired: currentValues.isRequired,
            });
            
            // Re-sync choice fields
            newFormState.forEach((item, ind) => {
                form.setFieldsValue({
                    [`choiceName${ind}`]: item.choiceName,
                    [`price${ind}`]: item.price,
                    [`calories${ind}`]: item.calories,
                });
            });
        }, 0);
        
        setFormState(newFormState);
    };

    const handleFieldChange = (index, field, value) => {
        setFormState(prevState => prevState.map((item, i) => (i === index ? {...item, [field]: value} : item)));
        form.setFieldsValue({[`${field}${index}`]: value});
    };

    const removeVariation = indexToRemove => {
        const newFormState = formState.filter((_, i) => i !== indexToRemove);
        
        // Re-sync all form field values after removal to prevent validation errors
        const currentValues = form.getFieldsValue();
        setTimeout(() => {
            form.setFieldsValue({
                groupName: currentValues.groupName,
                minChoice: currentValues.minChoice,
                maxChoice: currentValues.maxChoice,
                isRequired: currentValues.isRequired,
            });
            
            // Re-sync remaining choice fields with new indices
            newFormState.forEach((item, ind) => {
                form.setFieldsValue({
                    [`choiceName${ind}`]: item.choiceName,
                    [`price${ind}`]: item.price,
                    [`calories${ind}`]: item.calories,
                });
            });
        }, 0);
        
        setFormState(newFormState);
    };

    const handleOptionClick = (option, index) => {
        setFormState(prevState => prevState.map((item, i) => (i === index ? {...item, availability: option} : item)));
        setOpenDropdownIndex(null);
    };

    const toggleDropdown = index => {
        setOpenDropdownIndex(prevIndex => (prevIndex === index ? null : index));
    };

    const DropdownRef = useRef(null);
    const handleClickOutside = event => {
        if (DropdownRef.current && !DropdownRef.current.contains(event.target)) {
            setOpenDropdownIndex(null);
        }
    };

    useEffect(() => {
        document.addEventListener("mousedown", handleClickOutside);
        return () => document.removeEventListener("mousedown", handleClickOutside);
    }, []);

    // update subChoices for a specific choice index
    const handleSaveSubChoices = (choiceIndex, subChoicesArr) => {
        setFormState(prev => {
            const copy = [...prev];
            copy[choiceIndex] = {...copy[choiceIndex], subChoices: subChoicesArr || []};
            return copy;
        });
    };

    const handleSubmit = async data => {
        try {
            setLoading(true);

            const transformedChoices = formState.map(it => ({
                ...it,
                price: it.price === "" ? null : parseFloat(it.price),
                calories: it.calories === "" ? null : parseFloat(it.calories),
            }));

            const formattedData = {
                groupName: data.groupName,
                minChoice: data.minChoice,
                maxChoice: data.maxChoice,
                isRequired: data.isRequired === "true" || data.isRequired === true,
                choices: transformedChoices,
                branchId: defaultStore,
                restaurantId: businessId,
            };

            let res;
            if (editChoice && dataToUse._id) {
                res = await menuStoreService.updateChoiceGroup(formattedData, dataToUse._id);
            } else {
                res = await menuStoreService.createChoiceGroup(formattedData);
            }

            Toast({
                type: "success",
                message:
                    res?.message ||
                    (editChoice ? "Choice group updated successfully" : "Choice group created successfully"),
            });

            if (onSuccess) onSuccess();
            if (setGroupChoices && !editChoice && res?.data) {
                setGroupChoices(prev => (Array.isArray(prev) ? [res.data, ...prev] : prev));
            }

            onClose();
        } catch (error) {
            Toast({
                type: "error",
                message: error?.message || "Something went wrong",
            });
        } finally {
            setLoading(false);
        }
    };

    return (
        <AddMenuStyles>
            <Form form={form} onSubmit={handleSubmit}>
                <Form.Item
                    label="Choice Group Name *"
                    type="text"
                    rounded
                    name="groupName"
                    lg
                    placeholder="Enter your group choice name"
                    $bgWhite
                    rules={[{required: true, message: "Group name is required"}]}>
                    <Field />
                </Form.Item>
                <span className="choice-example">Example: Choice of Sides, Choice of Extras</span>

                <div className="combine-fields">
                    <div className="fields-below-text">
                        <Form.Item
                            label="Minimum number of Choices *"
                            type="number"
                            min={0}
                            rounded
                            name="minChoice"
                            lg
                            placeholder="0"
                            $bgWhite
                            rules={[{required: true, message: "Minimum number is required"}]}>
                            <Field />
                        </Form.Item>
                        <span className="choice-example">Enter "0" if this group is optional for your customers.</span>
                    </div>
                    <div className="fields-below-text">
                        <Form.Item
                            label="Maximum Number of Choices *"
                            type="number"
                            min={0}
                            rounded
                            name="maxChoice"
                            lg
                            placeholder="0"
                            $bgWhite
                            rules={[{required: true, message: "Maximum number is required"}]}>
                            <Field />
                        </Form.Item>
                        <span className="choice-example">Enter "1" if your customers can only choose 1</span>
                    </div>
                </div>

                <hr />
                <strong className="title choice-detail-title">Choice Group Details</strong>
                <p className="choice-detail">
                    Add choices for your customer to pick from, for example, French Fries or Salad. You can also add
                    existing menu items as a choice.
                </p>

                {formState.map((item, ind) => (
                    <div key={ind}>
                        <div className="choice-head">
                            <div className={`dropdownWrap ${item.availability.toLowerCase()}`}>
                                <div className="modal-dropdown" ref={DropdownRef}>
                                    <div className={`dot ${item.availability.toLowerCase()}`}></div>
                                    <div className="dropdown" onClick={() => toggleDropdown(ind)}>
                                        <p className={`${item.availability.toLowerCase()}`}>{item.availability}</p>
                                        <IoMdArrowDropdown size={20} style={{color: "grey"}} />
                                    </div>
                                    {openDropdownIndex === ind && (
                                        <ul className="styled-select">
                                            {dropdownOptions.map(option => (
                                                <li
                                                    className={`${option.toLowerCase()}`}
                                                    key={option}
                                                    onClick={() => handleOptionClick(option, ind)}>
                                                    {option}
                                                </li>
                                            ))}
                                        </ul>
                                    )}
                                </div>
                            </div>
                            <Button danger sm onClick={() => removeVariation(ind)} type="button">
                                <MdDelete />
                                Delete
                            </Button>
                        </div>

                        <div className="combine-fields">
                            <Form.Item
                                label="Choice Name"
                                placeholder="Choice Name"
                                type="text"
                                rounded
                                value={item.choiceName}
                                name={`choiceName${ind}`}
                                onChange={e => handleFieldChange(ind, "choiceName", e.target.value)}
                                lg
                                $bgWhite>
                                <Field />
                            </Form.Item>
                            <Form.Item
                                label="Enter Price"
                                placeholder="Leave blank for free"
                                type="number"
                                min={0}
                                step="any"
                                rounded
                                value={item.price}
                                name={`price${ind}`}
                                onChange={e => handleFieldChange(ind, "price", e.target.value)}
                                lg
                                $bgWhite>
                                <Field />
                            </Form.Item>
                        </div>

                        <Form.Item
                            label="Calories (per serving)"
                            placeholder="e.g., 250 or 4.0"
                            type="number"
                            min={0}
                            step="any"
                            rounded
                            value={item.calories}
                            name={`calories${ind}`}
                            onChange={e => handleFieldChange(ind, "calories", e.target.value)}
                            lg
                            $bgWhite>
                            <Field suffix="kcal" />
                        </Form.Item>

                        <ModalContainer
                            width={850}
                            title="Create Sub Choice Group"
                            btnComponent={({onClick}) => (
                                <div className="btn">
                                    <p className="sub-choice-btn" onClick={onClick}>
                                        {item.subChoices.length > 0 ? "Edit Sub-Choices" : "+ Add Sub-Choices"}
                                    </p>
                                </div>
                            )}
                            content={({onClose: modalClose}) => (
                                <SubChoiceModal
                                    isEdit={true}
                                    initialSubChoices={item.subChoices || []}
                                    onSave={subChoices => {
                                        handleSaveSubChoices(ind, subChoices);
                                        modalClose();
                                    }}
                                    onClose={modalClose}
                                />
                            )}
                        />
                    </div>
                ))}

                <hr />
                <div className="btn-holder">
                    {editChoice && (
                        <div className="btn">
                            <Button danger type="button" onClick={onClose}>
                                <MdDelete />
                                Delete Choice
                            </Button>
                        </div>
                    )}

                    <div className="btn">
                        <Button gray type="button" onClick={addFeilds}>
                            + Add Choice
                        </Button>
                    </div>
                    <div className="btn">
                        <Button type="submit" loader={loading}>
                            {editChoice ? "Save Choice" : "Create Choice"}
                        </Button>
                    </div>
                </div>
            </Form>
        </AddMenuStyles>
    );
};

export default ChoiceModal;
